import { Component, OnInit,OnChanges, Input,ViewChild ,EventEmitter, Output} from '@angular/core';
import { Subscription, throwError} from 'rxjs';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatTable,MatTableDataSource} from '@angular/material/table';
import { LogoService } from '../../services/logo.service';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faChartLine, faUnderline, faFile, faFileCsv, faFileDownload,faFileExcel,faFileCode } from '@fortawesome/free-solid-svg-icons';


import * as XLSX from 'xlsx';

@Component({
  selector: 'app-table-grid',
  templateUrl: './table-grid.component.html',
  styleUrls: ['./table-grid.component.scss']
})
export class TableGridComponent implements OnInit,OnChanges {
  
  
  private logosData$: Subscription;
  logosData:any;

  @Input() tableDef;
  @Input() data;
  @Input() loading;

  @Output() edit = new EventEmitter<number>();
  @Output() reload = new EventEmitter<number>();
  @Output() select = new EventEmitter<number>();

  @Input() pagedOn?=true;
  @Input() filterOn?=true;
  @Input() sortOn?=true;

  @ViewChild(MatSort,{ static: true }) sort: MatSort;
  @ViewChild(MatPaginator,{ static: true }) paginator: MatPaginator;

  @ViewChild('selectOverlay') selectOverlay;

  public dataTable = new MatTableDataSource();
  
  public headerGroupColumnsArray;
  public headerColumnsArray;
  public headerColumnsFilterArray;
  activeFilters = {};

  public selectedRow=null;

  
  constructor(library: FaIconLibrary,    
    public logoService: LogoService,) { 
    
    library.addIcons(faChartLine,faFile, faFileCsv, faFileDownload,faFileExcel,faFileCode );
  }

  ngAfterContentChecked(): void{
    
    // set the headers to the right size when the data changes
    this.alignGridHeaders();
 
  }

  ngOnInit(){


        // wire up the logos
        this.logosData$ = this.logoService.logos$.subscribe(
          (responsedata: any) => {
            if(responsedata!=null){                  
              if(responsedata.loading){
              } else {
                this.logosData = responsedata["data"];   
              }
            }
          }
        )
    
        if(this.logosData==undefined) this.logoService.loadLogos();


    // bind the MatTableDataSource to the table and the sort/page
    this.dataTable = new MatTableDataSource(this.data)
    if(this.tableDef.sortOn) this.dataTable.sort = this.sort;
    if(this.tableDef.pagedOn) this.dataTable.paginator = this.paginator;  

    this.tableDef.headerGroups = [];

    this.headerColumnsArray = [];
    this.headerColumnsFilterArray = [];
    this.tableDef.fields.forEach(x => {
      this.headerColumnsArray.push(x["name"]);
      if(x["displayname"]){
        this.headerColumnsFilterArray.push(x["displayname"] + "_filter");
      }else{
        this.headerColumnsFilterArray.push(x["name"] + "_filter");
      }
    });

    // overide the filter to filter just the selected column    
    let ngThis = this;
    this.dataTable.filterPredicate = function (data, filter: string): boolean {
      return ngThis.filterPredicate(data, filter)
    }
  
    setTimeout(() => {
      this.fixColumnWidths();
      },0);
      
  }

  ngAfterViewInit(){
   
  }

  ngOnChanges(): void {
    //console.log("-- changes")
    //console.log(JSON.stringify(this.data))
    this.removeColumnWidths();      
    this.dataTable.data = this.data;
      
  }

  reloadData(){
    // console.log("Show Info")
    this.reload.emit();
  }


  getLogo(val:string){
        let rtn = "";
    if(!this.logosData) return "";
    this.logosData.forEach(x => {      
      if(x.name==val) {
        rtn = x.file
      }   
    });
    return rtn;
  }


  export(type){

    if(type=="xlsx"){

        // Create an Array of Arrays - with the header as the first row
        let outdata = [];
        let row = [];
        let wscols = [];
        this.tableDef.fields.forEach(x => {
          row.push(x.label ? x.label : x.name);
          wscols.push({wpx: x.width ? +x.width.replace("px","") : 200});
        });
        outdata.push(row);
        
        this.data.forEach(d => {
          let drow=[];
          this.tableDef.fields.forEach(x => {
            drow.push(d[x.name]);
          });
          outdata.push(drow);
        });

        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(outdata)
        ws["!cols"] = wscols;

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, 'Estate-Maps-Data.xlsx');

    } else if(type=="csv"){

          const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
          const header = Object.keys(this.data[0]);
          let csv = this.data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer).replace(/\\"/g, '""')).join(','));
          csv.unshift(header.join(','));
          csv = csv.join('\r\n');
          this.download(csv, "Estat-Maps-Data.csv","text/text")

    } else if(type=="json"){
      this.download(JSON.stringify(this.data, undefined, 2), "Estat-Maps-Data.json","text/json")
    }
  }

   download(content, fileName, contentType) {
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    const filterName = (event.target as HTMLInputElement).name;
    
    // Pass the column and the filter to the filter
    this.dataTable.filter = JSON.stringify({filterValue:filterValue,filterName:filterName});

  }

  trackBy(index,item){
    return item.position;
  }

  hasFilter(ftype){
    if(ftype=="button" || ftype=="externallink" || ftype=="drilllink") {
      return false;
    } else {
      return true;
    }
  }

  pageChange(){
    // scroll the table to the top
    console.log("scroll to the top")
    document.getElementsByClassName("table-container")[0].scrollTop = 0
  }

  sortChange(){
    // set to first page
    this.paginator.firstPage();
  }

  // for the grid colors - special classes for red/green/amber so ignore them and FFFFFF
  filterColor(c:string){
    if(!c || c==null) return "";
    if(c.toLowerCase()=="red" || c.toLowerCase()=="amber" || c.toLowerCase()=="green" || c.toLowerCase()=="yellow" || c.toLowerCase()=="ffffff" ){
      return "";
    } else {
      return c;
    }    
  }

  classColor(c:string){
    if(!c || c==null) return "";
    return c.toLowerCase() + '-cell'
  }

  stringIsNumber(s) {
    if(s.trim()=="") return false;
    return !isNaN(s)
  }

  bifn(x){
    if(x == undefined) return "";
    if(x == null) return "";
    return x.toString();
  }

  
  removeColumnWidths(){
    
    // remove the old table width settings

    let stylesheet = document.styleSheets[0]
    let ruleList = document.styleSheets[0].cssRules;
    for (let i=ruleList.length - 1; i >= 0; i--) {
      if(ruleList[i].cssText.includes("mat-column-field")){
        stylesheet.removeRule(i)
      }
    }
  }

  fixColumnWidths(){

    // fix the column widths - get the size from the first render and add a class to fix the table cells to that size
    
    let stylesheet = document.styleSheets[0]

    let hcell : Element[] = Array.from(document.getElementsByClassName("scnd-header"));
    hcell.forEach((x,i) => {      
      // set the column min width to the size - this just fixes it if there is no data
      if (this.tableDef.tableName !== 'framenames') {
        x["style"]["min-width"] = x.clientWidth + "px";
      }
      // add a class to set the width of the table cell - set it to overflow with "..."
      stylesheet.insertRule(".mat-column-field" + (i+1) + " { max-width: " + x.clientWidth + "px; text-overflow: ellipsis;overflow: hidden}",0)
    });

  }

  alignGridHeaders(){

    if(this.filterOn){

      // Manualy adjust the height of the Filter Row depending on the height of the Second Header
      // required to stop the filter bar scrolling above the second header

      // get the height of the second header
      let hcell: Element[] = Array.from(document.getElementsByClassName("scnd-header"));
      let h = 0
      hcell.forEach(x => {
        if (h < x.clientHeight) h = x.clientHeight
      });

      // console.log("bheight:" + h)
      let fhcell: Element[] = Array.from(document.getElementsByClassName("thrd-header"));
      // if the first header is showing add 37px plus the height of the second header
      fhcell.forEach(x => {
        x["style"].top = (h + (this.tableDef.headerGroups.length > 0 ? 37 : 0)) + "px"
      });
    }

  }

  clickRow(row){
    if(this.selectedRow == row){
      this.selectedRow = null;
      this.select.emit(null);
    } else {
      this.selectedRow = row;
      this.select.emit(row["id"]);
    }      
  }

  dblClickEdit(row){
    this.selectedRow = row;
    this.edit.emit(row["id"])
  }




  filterPredicate (data, filter: string): boolean {

    // ******************************************
    // TODO - need to fix this to use the types
    // ******************************************
    
    // console.log("Filter:" + filter)
    // console.log("activeFilters:" + JSON.stringify(ngThis.activeFilters))
  
    const f = JSON.parse(filter);
  
    // Keep a list of the active filters
    this.activeFilters[f["filterName"]] = f["filterValue"].trim();
  
    let rtn = true;
    Object.keys(this.activeFilters).forEach(x => {
      if(this.activeFilters[x] != ""){
  
        // Kevin's list of things to filter for
        let special:boolean = false;
        const fvalue:string = this.activeFilters[x].trim()
        let t:string = this.bifn(this.bifn(data[x])) // if we format probably should put the text in here
        let v:string = data[x]
        
        // let n:boolean = data[x].align == "right" ? true : false
  
        if(fvalue==">" || fvalue=="<" || fvalue=="?"){
          special = true;
          if(t.trim()==""){              
            rtn = false
          }
        } else if(fvalue.includes("<") && fvalue.includes(">")){
          // bigger than and less than
          let iless = fvalue.indexOf("<") + 1
          let imore = fvalue.indexOf(">") + 1
  
          let lessstring = fvalue.substring(iless,(imore>iless?imore-1:fvalue.length)).trim();
          // console.log("less string:" + lessstring)
          let morestring = fvalue.substring(imore,(iless>imore?iless-1:fvalue.length)).trim();
          // console.log("more string:" + morestring)
  
          // get rid of anything passed the first string to take out the and from "20 and"
          let i1 = lessstring.indexOf(" ");
          if(i1>-1){
            lessstring = lessstring.substr(0,i1)
          }
  
          let i2 = morestring.indexOf(" ");
          if(i2>-1){
            morestring = morestring.substr(0,i2)
          }
  
          // console.log("==less string:" + lessstring)
          // console.log("==more string:" + morestring)
          if(this.stringIsNumber(lessstring) && this.stringIsNumber(morestring)){
            special = true;
            if(+v > +lessstring || +v < +morestring){
              rtn = false;
            }
          } else {
            special = false;
          }
          
        } else if(fvalue.startsWith(">")){            
          // bigger than
          let fnum = fvalue.replace(">","")
          
          // if no number specified just do no blanks
          if(this.stringIsNumber(fnum)){
            special = true;
            if(+v < +fnum){
              rtn = false;
            }
          } else {              
            special = true;
            rtn = false              
          }
      
        } else if(fvalue.startsWith("<")){            
          // less than
          let fnum = fvalue.replace("<","")
          
          // if no number specified just do no blanks
          if(this.stringIsNumber(fnum)){
            special = true;
            if(+v > +fnum){
              rtn = false;
            }
          } else {              
            special = true;
            rtn = false              
          }
      
        } else if (fvalue.startsWith("!")){
          // not
          let fnew = fvalue.replace("!","").trim()
          special = true;
          if(t.toLowerCase().includes(fnew.toLowerCase())){
            rtn = false;
          }
        } else if (fvalue.startsWith("/")){
          // regex
          special = true;
          try {
  // console.log("regex:" + f)
  let a = fvalue.split("/");
  let modifiers= a.pop(); a.shift();
  let pattern = a.join("/");
  let rgx =  new RegExp(pattern, modifiers);
            
            if(!rgx.test(t)){
              rtn = false;
            }
          } catch {
            // not valid regex
            // console.log("not valid")
            special = false;
          }            
        } 
  
        // if not special just do a lowercase contains
        if(!special) {
          // contains 
          // console.log("x >> " + x);
          // console.log("data >> " + JSON.stringify(data));
          let d = this.bifn(data[x]);
          if(!d.toLowerCase().includes(this.activeFilters[x].trim().toLowerCase())){
            rtn = false;
          }
        }
        
      }
    });
    
    return rtn;
  }

  formatDate(d) {
    if(d){
      let date = new Date(d);
      let YY = date.getFullYear() + '-';
      let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return YY + MM + DD +" "+hh + mm + ss;
    }else{
      return "";
    }
  }

}
